<template>
  <v-container fluid class="pa-0 pa-md-2">
    <router-view />
  </v-container>
</template>

<script>

export default {
  name: 'FrontPageMain',
};
</script>
